import { ReactComponent as TrashIcon } from "../assets/icons/trash.svg";
import { ReactComponent as PencilIcon } from "../assets/icons/pencil.svg";
import { ReactComponent as CloneIcon } from "../assets/icons/clone.svg";
import CachedIcon from "@material-ui/icons/Cached";
import { useState } from "react";

const TableActions = ({
  onUpdateClick,
  onDeleteClick,
  onCloneClick,
  item_id,
  item_index,
  deleteIcon,
  deleteClass,
  onResendClick,
  noActions,
  updateBtnLabel = "Update",
  infoTooltip,
  onlyUpdateAllowed = false
}) => {
  const [isResending, setIsResending] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const DeleteIcon = deleteIcon || TrashIcon;

  const handleResend = (event) => {
    setIsResending(true);
    onResendClick((err, response) => {
      if (!err) return;

      setIsResending(false);
      // disables the button
      event.target.disabled = true;
    });
  };

  const handleMouseEnter = () => setTooltipVisible(true);
  const handleMouseLeave = () => setTooltipVisible(false);
  const handleFocus = () => setTooltipVisible(true);
  const handleBlur = () => setTooltipVisible(false);

  if (onlyUpdateAllowed) {
    return (
      <>
        {onUpdateClick && (
          <button
            type="button"
            className="flex items-center border py-1 px-4 rounded-full ttnk-border-color update-button ttnk-button-color ttnk-icon text-white"
            onClick={() => onUpdateClick(item_id, item_index)}
          >
            {updateBtnLabel === "Resend" ? (
              <CachedIcon style={{ marginRight: 4 }} />
            ) : (
              <PencilIcon className="h-4 w-4 mr-2 fill-current pencil" />
            )}
            {updateBtnLabel}
          </button>
        )}
      </>
    )
  }

  if (noActions)
    return <span className="flex items-center">No Actions Allowed</span>;

  return (
    <span className="flex items-center">
      {onUpdateClick && (
        <button
          type="button"
          className="flex items-center border py-1 px-4 rounded-full ttnk-border-color update-button ttnk-button-color ttnk-icon text-white"
          onClick={() => onUpdateClick(item_id, item_index)}
        >
          {updateBtnLabel === "Resend" ? (
            <CachedIcon style={{ marginRight: 4 }} />
          ) : (
            <PencilIcon className="h-4 w-4 mr-2 fill-current pencil" />
          )}
          {updateBtnLabel}
        </button>
      )}
      {onCloneClick && (
        <button type="button" onClick={() => onCloneClick(item_id, item_index)}>
          <CloneIcon className="h-5 w-5 fill-current text-gray-400 trash ml-2 hover:text-aeblue" />{" "}
        </button>
      )}
      {onDeleteClick && (
        <button
          type="button"
          className="ml-2"
          onClick={() => onDeleteClick(item_id, item_index)}
        >
          <DeleteIcon
            className={
              deleteClass ||
              "h-5 w-5 fill-current text-gray-400 trash hover:text-red-600"
            }
          />
        </button>
      )}
      {!!onResendClick && (
        <button
          disabled={isResending}
          onClick={handleResend}
          className="ttnk-button ml-2"
        >
          Resend
        </button>
      )}
      {infoTooltip && (
        <button
          type="button"
          className="relative ml-4"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onFocus={handleFocus}
          onBlur={handleBlur}
        >
          <svg
            height="14px"
            width="14px"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
          </svg>

          {tooltipVisible && (
            <span className="absolute left-full top-1/2 transform -translate-y-1/2 opacity-100 transition-opacity bg-white text-black text-xs px-4 py-3 ml-2 rounded-md border border-gray-300 shadow-md whitespace-nowrap z-10">
              {infoTooltip}

              <span className="absolute left-[-8px] top-1/2 transform -translate-y-1/2 w-0 h-0 border-t-[6px] border-b-[6px] border-r-[6px] border-transparent border-r-gray-300 bg-white"></span>
            </span>
          )}
        </button>
      )}
    </span>
  );
};

export default TableActions;
